import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./PhotoBoard.module.css";
import LinkHeader from "./components/LinkHeader";
import PhotoItem from "./components/PhotoItem";

export default function PhotoBoardPreview(props) {
  const { title, api, to, forceTo, category_id } = props;
  const navigate = useNavigate();

  let [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/api/${api}/articles?category_id=${category_id}&page=0&limit=3`
      )
      .then(async (res) => {
        if (res.data.length !== 0) {
          setData([...data, ...res.data]);
        } else {
          setData([]);
        }
      });
  }, []);

  const move = (n) => {
    navigate(`/${api}/article/${n}`, { state: { article_id: n } });
  };

  return (
    <div className={styles.PhotoBoardPreview}>
      <LinkHeader
        title={title}
        to={forceTo != undefined ? `${forceTo}` : `${to}/${category_id}`}
        state={{ title: title }}
      />
      <div className={styles.ItemContainer}>
        {data.length === 0 ? (
          <div></div>
        ) : (
          data.map(({ id, title, name, image }, index) => {
            return (
              <PhotoItem
                id={id}
                title={title || name}
                imgPath={image[0]}
                onClickHandler={move}
                key={index}
              />
            );
          })
        )}
      </div>
    </div>
  );
}
